import { getVehicleAttributeIds } from 'helpers/vehicle';

/**
 * Builds the shift request object.
 */
function buildShiftRequestObject(values) {
  const {
    vehicle,
    engine,
    transmission,
    traction,
    advisor,
    worker,
    workshop,
    addons,
    personal_information,
    license_plate,
    date,
    hour,
    is_under_warranty,
    legacy_service,
    requests_taxi,
    services,
    wants_dynamic_reception,
    chassis,
    public_use,
    has_modifications,
    estimated_kms,
    maintenance_plan_id,
  } = values;

  const vehicleAttrs = getVehicleAttributeIds(vehicle, engine, transmission, traction);

  const worker_id = worker ? worker.id : null;
  const advisor_id = advisor ? advisor.id : null;
  const workshop_id = workshop.id;
  const addonServices = addons ? addons.map(addon => addon.id) : [];
  const selectedServices = services.reduce((services, service) => {
    services[service.id] = {
      comments: service.comments,
      type: service.plus ? 'plus' : '',
    };

    return services;
  }, {});

  return {
    ...vehicleAttrs,
    advisor_id,
    worker_id,
    workshop_id,
    personal_information,
    license_plate,
    date,
    hour,
    is_under_warranty,
    legacy_service,
    requests_taxi,
    wants_dynamic_reception,
    chassis,
    public_use,
    has_modifications,
    estimated_kms,
    maintenance_plan_id,
    services: selectedServices,
    addons: addonServices,
  };
}

/**
 * Return the display price of a service.
 *
 * @param {Object} service
 * @param {Object} options { legacyService }
 * @param {Object} flags { ... }
 */
function price(service, options, flags = {}) {
  service = Object.assign({}, service, flags);

  const partiallyBonified = options.vehicleName && !options.vehicleName.includes('vento') && !options.vehicleName.includes('tiguan');

  if (service.bonified && !partiallyBonified) {
    return 0;
  }

  if (service.plus) {
    return service.price_plus;
  }

  if (options.legacyService && options.brand === 'vw') {
    return service.price_premium;
  }

  if (service.price_promotion) {
    return service.price_promotion;
  }

  return service.price_default;
}

/**
 * Return the internal name of the price of a service.
 *
 * @param {Object} service
 * @param {Object} options { legacyService }
 */
function priceType(service, options) {
  if (options.legacyService && options.brand === 'vw') {
    return priceTypes.LEGACY;
  }

  if (service.price_promotion) {
    return priceTypes.PROMOTION;
  }

  if (service.plus) {
    return priceTypes.PLUS;
  }

  return service.price_default == 1 ? priceTypes.HIDDEN : priceTypes.DEFAULT;
}

const priceTypes = {
  HIDDEN: 'hidden',
  DEFAULT: 'default',
  PROMOTION: 'promotion',
  PLUS: 'plus',
  LEGACY: 'default',
};

export default {
  price,
  priceType,
  priceTypes,
  buildShiftRequestObject,
};
